<template>
  <div class="reviewer-package-list">
    <div class="bock-desc" v-if="packageList.length>0">Offering List</div>
    <div v-if="disabled" class="reviewer-package-item-disabled" v-for="item in packageList" :key="item._id.$oid+'disabled'">
      <div class="title">{{ item.title }}</div>
      <div>
        <span>{{ $t("Price") }}:</span>
        <span>{{ item.price ? "$" + (item.price / 100).toFixed(2) : "free" }}</span>
      </div>
    </div>
    <div v-if="!disabled" class="reviewer-package-item" v-for="item in packageList" :key="item._id.$oid+'enable'">
      <md-checkbox v-model="selectedList" :value="item._id.$oid">
        <div class="title">{{ item.title }}</div>
        <div>
          <span>{{ $t("Price") }}:</span>
          <span>{{ item.price ? "$" + (item.price / 100).toFixed(2) : "free" }}</span>
        </div>
      </md-checkbox>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReviewerPackage",
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    onChange: {
      type: Function,
      default: () => { }
    },
    packageList: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    selectedList: []
  }),
  watch: {
    selectedList(val) {
      this.onChange(val)
    },
    packageList(list) {
      if(list && list.length) {
        this.selectedList = [...list].map(item => item._id.$oid)
      }
    }
  }
}
</script>

<style lang="scss">
.reviewer-package-list {
  padding-right: 20px;
  padding-bottom: 24px;
  font-size: 12px;
  color: #333;
  .bock-desc {
    font-size: 14px;
    font-weight: 500;
  }
  .title {
    font-weight: 500;
  }
  .reviewer-package-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ccc;
    line-height: 16px;
    margin-left: 16px;
    .md-checkbox-label {
      margin-top: -10px;
    }
    
  }
  .reviewer-package-item-disabled {
    border-bottom: 1px solid #ccc;
    line-height: 20px;
    padding-bottom: 8px;
    margin-left: 16px;
  }
}
</style>